<template>

<svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_11_743)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.5001 19.7083C19.521 19.7083 17.9167 21.3125 17.9167 23.2916C17.9167 25.2707 19.521 26.8749 21.5001 26.8749C23.4792 26.8749 25.0834 25.2707 25.0834 23.2916C25.0834 21.3125 23.4792 19.7083 21.5001 19.7083Z" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M39.4162 17.0278C39.4162 17.0879 39.416 17.1486 39.416 17.2098V28.7845C39.4162 30.3728 39.4162 31.7413 39.2689 32.8373C39.1111 34.0117 38.7549 35.1374 37.8419 36.0506C36.9286 36.9638 35.8028 37.3198 34.6283 37.4777C33.5325 37.6251 32.1639 37.625 30.5756 37.625H12.4232C10.8349 37.625 9.46636 37.6251 8.37047 37.4777C7.19599 37.3198 6.0702 36.9638 5.15706 36.0506C4.24392 35.1374 3.88782 34.0117 3.72992 32.8373C3.58258 31.7413 3.58267 30.3728 3.58276 28.7845V17.2098C3.58276 17.1486 3.5827 17.0879 3.58263 17.0278C3.58184 16.2016 3.58116 15.4894 3.73401 14.8587C4.20816 12.9026 5.73546 11.3753 7.6916 10.9012C8.32223 10.7483 9.03449 10.749 9.86068 10.7498C9.92076 10.7498 9.98142 10.7499 10.0427 10.7499C10.6631 10.7499 10.7881 10.7452 10.8889 10.7301C11.2977 10.6688 11.6726 10.4682 11.9503 10.1621C12.0189 10.0865 12.092 9.98516 12.4362 9.46895L12.842 8.86023C12.883 8.7987 12.9236 8.73764 12.9639 8.67707C13.5511 7.79368 14.069 7.01454 14.8041 6.45975C15.2487 6.12414 15.7428 5.85971 16.2687 5.6759C17.1381 5.37205 18.0737 5.37329 19.1344 5.3747C19.2071 5.37481 19.2806 5.3749 19.3544 5.3749H23.6445C23.7183 5.3749 23.7918 5.37481 23.8645 5.3747C24.9252 5.37329 25.8608 5.37205 26.7301 5.6759C27.256 5.85971 27.7501 6.12414 28.1948 6.45975C28.9298 7.01454 29.4477 7.7937 30.035 8.67707C30.0752 8.73764 30.1158 8.79872 30.1569 8.86023L30.5627 9.46895C30.9069 9.98516 30.98 10.0865 31.0486 10.1621C31.3263 10.4682 31.7013 10.6688 32.11 10.7301C32.2108 10.7452 32.3357 10.7499 32.9562 10.7499C33.0174 10.7499 33.0782 10.7498 33.1382 10.7498C33.9643 10.749 34.6767 10.7483 35.3072 10.9012C37.2633 11.3753 38.7907 12.9026 39.2648 14.8587C39.4176 15.4894 39.4169 16.2016 39.4162 17.0278ZM14.333 23.2916C14.333 19.3336 17.5416 16.125 21.4997 16.125C25.4577 16.125 28.6664 19.3336 28.6664 23.2916C28.6664 27.2496 25.4577 30.4583 21.4997 30.4583C17.5416 30.4583 14.333 27.2496 14.333 23.2916Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_11_743">
<rect width="43" height="43" fill="white"/>
</clipPath>
</defs>
</svg>

</template>

<script>
export default {
  name: 'IconBtnCamOn',
  components: {
  },

  data: () => {
    return {
    }
  },

  mounted () {
  },

  methods: {
  }
}
</script>
